import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e2e1910"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root" }
const _hoisted_2 = { class: "headers" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "エンジン名: ", -1))
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "header" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "最善手: ", -1))
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "header" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "秒間探索ノード(NPS): ", -1))
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "header" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "探索ノード数: ", -1))
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "header" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "ハッシュ使用率: ", -1))
const _hoisted_17 = { class: "value" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"list-header\" data-v-1e2e1910><div class=\"list-column time\" data-v-1e2e1910>経過時間</div><div class=\"list-column multipv-index\" data-v-1e2e1910>順位</div><div class=\"list-column depth\" data-v-1e2e1910>深さ</div><div class=\"list-column score\" data-v-1e2e1910>評価値</div></div>", 1)
const _hoisted_19 = { class: "list-column time" }
const _hoisted_20 = { class: "list-column multipv-index" }
const _hoisted_21 = { class: "list-column depth" }
const _hoisted_22 = { class: "list-column score" }
const _hoisted_23 = { class: "list-column score-flag" }
const _hoisted_24 = { class: "list-column text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.name), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.info.currentMoveText || "---"), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.info.nps || "---"), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.info.nodes || "---"), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.info.hashfull ? (_ctx.info.hashfull * 100).toFixed(1) : "---") + " % ", 1)
        ])
      ]),
      _hoisted_18,
      _createElementVNode("div", {
        class: "list",
        style: _normalizeStyle(`height:${_ctx.height - 37}px`)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.iterates, (iterate, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "list-item"
          }, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(iterate.timeMs ? (iterate.timeMs / 1e3).toFixed(1) + "s" : ""), 1),
            _createElementVNode("div", _hoisted_20, _toDisplayString(iterate.multiPV || ""), 1),
            _createElementVNode("div", _hoisted_21, _toDisplayString(iterate.depth) + _toDisplayString(iterate.selectiveDepth && iterate.depth ? "/" : "") + _toDisplayString(iterate.selectiveDepth), 1),
            _createElementVNode("div", _hoisted_22, _toDisplayString(iterate.score) + " " + _toDisplayString(iterate.scoreMate ? iterate.scoreMate : ""), 1),
            _createElementVNode("div", _hoisted_23, _toDisplayString(iterate.lowerBound ? "++" : "") + " " + _toDisplayString(iterate.upperBound ? "--" : "") + " " + _toDisplayString(iterate.scoreMate ? "詰" : ""), 1),
            _createElementVNode("div", _hoisted_24, _toDisplayString(iterate.text), 1)
          ]))
        }), 128))
      ], 4)
    ])
  ]))
}